
'use client';

import { AppLayout } from '@/components/app-layout';
import { CreatePostForm } from '@/components/create-post-form';
import { LeftSidebar } from '@/components/left-sidebar';
import { PostCard } from '@/components/post-card';
import { RightSidebar } from '@/components/right-sidebar';
import { usePosts } from '@/context/PostContext';
import { Skeleton } from '@/components/ui/skeleton';
import { useAuth } from '@/context/AuthContext';
import { PostProvider } from '@/context/PostContext';
import { PortfolioProvider } from '@/context/PortfolioContext';
import { Button } from '@/components/ui/button';
import { Loader2 } from 'lucide-react';

function HomePageContent() {
  const { posts, loading, hasMore, fetchMorePosts, loadingMore } = usePosts();
  const { user } = useAuth();

  return (
    <AppLayout>
      <div className="grid lg:grid-cols-[300px_1fr_300px] xl:grid-cols-[360px_1fr_360px] min-h-[calc(100vh-56px)]">
        {/* Desktop Left Sidebar */}
        <aside className="hidden lg:block lg:sticky top-14 h-[calc(100vh-56px)] border-r">
          <LeftSidebar />
        </aside>

        <main className="col-span-1 py-6 px-4 md:px-6 lg:px-8">
          <div className="max-w-2xl mx-auto space-y-6">
            <CreatePostForm author={user} />
            {loading ? (
              <>
                <Skeleton className="h-[250px] w-full rounded-lg" />
                <Skeleton className="h-[250px] w-full rounded-lg" />
              </>
            ) : (
               posts.map(post => (
                <PostCard key={post.id} post={post} />
              ))
            )}
            {hasMore && (
              <div className="flex justify-center">
                <Button onClick={fetchMorePosts} disabled={loadingMore}>
                  {loadingMore && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
                  Load More
                </Button>
              </div>
            )}
          </div>
        </main>
        
        {/* Desktop Right Sidebar */}
        <aside className="hidden lg:block lg:sticky top-14 h-[calc(100vh-56px)] border-l">
          <RightSidebar />
        </aside>
      </div>
    </AppLayout>
  );
}

export default function Home() {
  return (
      <PostProvider>
        <PortfolioProvider>
          <HomePageContent />
        </PortfolioProvider>
      </PostProvider>
  );
}
